/* eslint-disable no-constant-condition */
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { API_CURRENCY } from 'config/constants'
import CurrencyAPI from '@everapi/currencyapi-js'
import { setCurrencyConverterData } from 'state/balances/actions'

const useGetCurrencyConverter = () => {
  const dispatch = useDispatch()

  const getCurrency = useCallback(() => {
    const currencyApi = new CurrencyAPI(API_CURRENCY)

    currencyApi
      ?.latest({
        base_currency: 'USD',
        currencies: 'VND,EUR',
      })
      .then((response) => {
        dispatch(setCurrencyConverterData(response?.data))
      })
  }, [dispatch])

  useEffect(() => {
    getCurrency()
  }, [getCurrency])

  return [getCurrency]
}

export default useGetCurrencyConverter
